import React from 'react'
import { withRouter } from 'next/router'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import staticFilesUrl from 'constants/staticFiles'
import LoginPrompt from 'components/sharedComponents/LoginPrompt'
import PublicProfilePage from 'components/pagesContent/PublicProfilePage'

const Img = styled.img`
  max-width: 238px;
`

const Illustration = () => (
  <Img
    aria-hidden
    alt="illustration inloggning"
    src={`${staticFilesUrl}/assets/images/public-profile-login.png`}
    srcSet={
      `${staticFilesUrl}/assets/images/public-profile-login@2x.png 2x, ` +
      `${staticFilesUrl}/assets/images/public-profile-login@3x.png 3x`
    }
  />
)

const PublicProfileIndex = ({ router: { query } }) => {
  const loggedIn = useSelector((state) => state.account.user.loggedIn)
  const publicProfileAccountId = query.blocketId

  if (!loggedIn) {
    return (
      <LoginPrompt
        redirectUri={`/profil/${publicProfileAccountId}`}
        cancelUri={`/profil/${publicProfileAccountId}`}
        icon={<Illustration />}
        headline="Vem där?"
        infoText="Logga in för att se personens profilsida."
        tag="public-profile"
      />
    )
  }
  return <PublicProfilePage publicProfileAccountId={publicProfileAccountId} />
}

PublicProfileIndex.propTypes = {
  router: PropTypes.object.isRequired,
}

export default withRouter(PublicProfileIndex)
